/**
 * @(#)2019/6/17.
 * String，可以输入所有内容
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import { Input } from "antd";
import { get, removeTrimStr } from "../../../utils";
import React from "react";
import { YxComponent } from "../../YxComponent";
import { omit } from "lodash";

export default class extends YxComponent {
  get value() {
    const value = get(this.props, "value", "");
    if (value instanceof Array) {
      const valueSplit = get(this.props, "valueSplit", ",");
      return value.join(valueSplit);
    } else {
      return value;
    }
  }

  onChange = (event) => {
    let value = get(event, "target.value", "");
    const isTrim = get(this.props, "isTrim", false);
    value = isTrim ? removeTrimStr(value) : value;
    get(this.props, "onChange", () => {})(value);
  };

  render() {
    return (
      <Input
        {...omit(this.props, ["isTrim"])}
        value={this.value}
        onChange={this.onChange}
      ></Input>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/String/baseString.js